import React from 'react';
import { Link } from 'react-router-dom';
import { SERVICES, servicePath } from '../../data/services.mjs';
import './navbar.css';

const Navbar = () => {
    return (
        <div className="fables-transparent py-3 py-lg-0">
            <div className="container">
                <div className="row">
                    <div className="col-12 col-md-12 pr-md-0">
                        <nav className="navbar navbar-expand-md btco-hover-menu py-lg-2" aria-label="Navegación principal">

                            <a className="navbar-brand fables-logo-brand pl-0" href="/">
                                <img src="/assets/custom/images/coralan-multiservice-logo.png" alt="Coralan Multiservice — desarrollo de software en República Dominicana"
                                className="fables-logo" width="523" height="160" />
                            </a>
                            <button className="navbar-toggler" type="button" data-toggle="collapse"
                                    data-target="#fablesNavDropdown" aria-controls="fablesNavDropdown"
                                    aria-expanded="false" aria-label="Abrir menú">
                                <span className="fables-iconmenu-icon text-primary font-16"></span>
                            </button>
                            <div className="collapse navbar-collapse" id="fablesNavDropdown">

                                <ul className="navbar-nav mx-auto fables-nav">
                                    <li className="nav-item fables-nav-dropdown">
                                        <Link className="nav-link" to="/servicios">
                                            Servicios <i className="fas fa-chevron-down fables-nav-caret" aria-hidden="true"></i>
                                        </Link>
                                        <ul className="fables-nav-submenu">
                                            <li><Link to="/servicios">Todos los servicios</Link></li>
                                            {SERVICES.map((s) => (
                                                <li key={s.slug}><Link to={servicePath(s.slug)}>{s.shortName}</Link></li>
                                            ))}
                                            <li><Link to="/facturacion-electronica">ERP con facturación electrónica</Link></li>
                                            <li><Link to="/productos">Productos</Link></li>
                                        </ul>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" href="/#whychooseus">
                                            ¿Por qué elegirnos?
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" href="/#aboutus">
                                            Nosotros
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" href="/#latestwork">
                                            Portafolio
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" href="/#ourplans">
                                            Precios
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" href="/#contactenos">
                                            Contáctenos
                                        </a>
                                    </li>
                                </ul>

                            </div>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Navbar;
